/** @format */

import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Button,
} from "reactstrap";
import { toast } from "react-toastify";
import http from "../../services/http";
import { getAPIURL } from "../../services/helper";
import { useDispatch } from "react-redux";
import {
  bulkEditProducts,
  setLoading,
} from "../../ReduxToolkit/Reducers/ProductsReducer";
import { updatePosItems } from "../../services/posItemsHelper";

export default function BulkEditModal({ isOpen, onToggle, selectedProducts }) {
  const api_url = getAPIURL();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    regular_price: "",
    sale_price: "",
    manage_stock: false,
    stock_quantity: "",
    purchase_instore_only: false,
  });

  useEffect(() => {
    if (selectedProducts.length > 0) {
      // Pre-fill the form with the values of the first selected product as a default
      const firstProduct = selectedProducts[0];
      setFormData({
        regular_price: firstProduct.regular_price || "",
        sale_price: firstProduct.sale_price || "",
        manage_stock: firstProduct.manage_stock || false,
        stock_quantity: firstProduct.stock_quantity || "",
        purchase_instore_only: firstProduct.purchase_instore_only === "yes",
      });
    }
  }, [selectedProducts]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleBulkEdit = async () => {
    try {
      console.log("sale price", formData.sale_price);
      const updateData = {
        regular_price: parseFloat(formData.regular_price),
        sale_price:
          parseFloat(formData.sale_price) === 0
            ? parseFloat(formData.regular_price)
            : parseFloat(formData.sale_price) ||
              parseFloat(formData.regular_price),
        manage_stock: formData.manage_stock,
        stock_quantity: parseFloat(formData.stock_quantity),
        purchase_instore_only: formData.purchase_instore_only ? "yes" : "no",
      };

      onToggle(); // Close modal
      dispatch(setLoading(true));
      const payload = {
        product_ids: selectedProducts.map((product) => product.id),
        update_data: updateData,
      };

      // Sending bulk update request to backend
      const { data } = await http.post(
        `${api_url}/products/bulk-edit`,
        payload
      );

      dispatch(setLoading(false));
      if (data.success) {
        toast.success("Bulk edit successful!");
        dispatch(bulkEditProducts(data.data.updated_products));
        // Update pos_items using helper function
        await updatePosItems(data.data.updated_products, dispatch);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error("Error in bulk edit:", error);
      toast.error("An error occurred while updating products.");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onToggle} size="lg">
      <ModalHeader toggle={onToggle}>Bulk Edit Product Details</ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            {/* Price Field */}
            <Col xs={6}>
              <FormGroup>
                <Label>Price</Label>
                <Input
                  type="number"
                  name="regular_price"
                  value={formData.regular_price}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>

            {/* Discount Price Field */}
            <Col xs={6}>
              <FormGroup>
                <Label>Discount Price</Label>
                <Input
                  type="number"
                  name="sale_price"
                  value={formData.sale_price}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>

            {/* Stock Management */}
            <Col xs={6}>
              <FormGroup check>
                <Input
                  id="manage_stock"
                  type="checkbox"
                  name="manage_stock"
                  checked={formData.manage_stock}
                  onChange={handleChange}
                />
                <Label htmlFor="manage_stock" check>
                  Enable Stock
                </Label>
              </FormGroup>

              {formData.manage_stock && (
                <Input
                  type="number"
                  name="stock_quantity"
                  placeholder="Stock Quantity"
                  value={formData.stock_quantity}
                  onChange={handleChange}
                  style={{ width: "100px" }}
                />
              )}
            </Col>

            {/* POS Restriction Checkbox */}
            <Col xs={6}>
              <FormGroup check>
                <Input
                  id="purchase_instore_only"
                  type="checkbox"
                  name="purchase_instore_only"
                  checked={formData.purchase_instore_only}
                  onChange={handleChange}
                />
                <Label htmlFor="purchase_instore_only" check>
                  Sell in store only
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={onToggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleBulkEdit}>
          Save Changesss
        </Button>
      </ModalFooter>
    </Modal>
  );
}
